import { useCallback, useState } from "react";

const getFromStorage = <T>(name: string, defaultValue?: T) => {
  try {
    const val = JSON.parse(localStorage.getItem(name) + "");
    if (val !== null) {
      return val;
    } else {
      localStorage.setItem(name, JSON.stringify(defaultValue));
      return defaultValue;
    }
  } catch {
    return defaultValue;
  }
};

const usePersistedState = <T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] => {
  const name = `persistState/${key}`;

  const [state, setState] = useState<T>(getFromStorage<T>(name, initialValue));

  const setValue = useCallback(
    (value: T) => {
      localStorage.setItem(name, JSON.stringify(value));
      setState(value);
    },
    [name]
  );

  return [state, setValue];
};

export default usePersistedState;
